import React from 'react';
import Modal from './Modal';

const ConfirmModal = ({
    isOpen,
    onClose,
    onConfirm,
    title = "Confirm Action",
    message = "Are you sure you want to proceed?",
    confirmText = "Confirm",
    cancelText = "Cancel",
    type = "danger",
    loading = false,
    maxWidth = "max-w-xl"
}) => {
    const footer = (
        <>
            <button
                onClick={onConfirm}
                disabled={loading}
                className={`px-8 py-3 rounded-2xl font-black uppercase text-[10px] tracking-widest text-white transition-all shadow-xl disabled:opacity-50 ${type === 'danger' ? 'bg-rose-500 hover:bg-rose-600 shadow-rose-900/10' : 'bg-[#18216D] hover:bg-[#0D164F] shadow-indigo-900/10'
                    }`}
            >
                {loading ? 'Processing...' : confirmText}
            </button>
            <button
                onClick={onClose}
                disabled={loading}
                className="px-8 py-3 bg-white border border-slate-200 text-slate-400 rounded-2xl font-black uppercase text-[10px] tracking-widest hover:border-slate-400 transition-all"
            >
                {cancelText}
            </button>
        </>
    );

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={title}
            type={type}
            footer={footer}
            maxWidth={maxWidth}
        >
            <p className="text-center sm:text-left">{message}</p>
        </Modal>
    );
};

export default ConfirmModal;
